module.exports = __webpack_public_path__ + "static/media/Olufemi Olomitutu-Frontend Developer.3dd201cb.pdf";